import { Link } from "react-router-dom";
import Icon from "@/components/base/Icon";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-2 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="text-foreground-500 cursor-pointer transition-colors hover:text-primary-600"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-900 font-medium" : "text-foreground-500"}>
                {item.label}
              </span>
            )}
            {!isLast && (
              <Icon name="ri-arrow-right-s-line" className="w-4 h-4 text-foreground-300" />
            )}
          </span>
        );
      })}
    </nav>
  );
}